module.exports = __webpack_public_path__ + "src/assets/chevron.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chevron.svg
// module id = 32
// module chunks = 0